<template>
  <div id="site">
    <!-- all_in -->
    <div class="con_all">
      <Button @click.native="back" style="margin:10px 10px 10px 25px">{{showPage.back}}</Button>
      <div v-for="(picture,index) in sites[siteindex].pictures" :key="index">
        <div style="margin:25px;max-width: 100%;"><img style="max-width: 100%;" :src="picture"></div>
      </div>
      <div class="fix"></div>
      <div class="con_box2">
        <div style="border-left: 3px solid #bbb; padding-left: 10px;font-size: 20px;margin-bottom: 20px;">{{showName(sites[siteindex])}}</div>
        <div class="site_link" v-html="showIntroduction(sites[siteindex])">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'site',
  props: ['sites'],
  data() {
    return {
      siteindex: this.$route.params.site,
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    // this.init();
  },
  watch: {
    $route() {
      this.siteindex = this.$route.params.site;
    }
  },
  methods: {
    init() {
      this.initSites();
    },
    initSites() {
      this.getSitesData();
    },
    getSitesData() {
      axios.get(API.site)
        .then(response => {
          this.sites = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },

    back() {
      // this.$router.go(-1);
      window.history.go(-1)
      
    },

    showName(site) {
      let show = { 'CH': site.nameCh, 'EN': site.nameEn }
      return show[sessionStorage.locale];
    },
    showIntroduction(site) {
      let introduction = {
        CH: (site.introductionCh),
        EN: (site.introductionEn)
      };
      return introduction[sessionStorage.locale];
    }
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// SiteInfo.vue?27b81146